import { Navigation } from './navigationService'
import { AuthStackScreenNames } from '../AuthStack'
import { FinanceScreenNames, MainStackScreenNames } from '../MainStack'
import { ImageSourcePropType } from 'react-native'
import { GenericInfoScreenContext } from '../../screens/ProfileScreens/constants'

export class Coordinator {
  static goBack() {
    Navigation.goBack()
  }
  static goToAppointments() {
    Navigation.navigate(MainStackScreenNames.Appointments)
  }
  static goToAssistance() {
    Navigation.navigate(MainStackScreenNames.Assistance)
  }
  static goToQuestions(category: string) {
    Navigation.navigate(MainStackScreenNames.Questions, { category })
  }
  static goToAnswers(category: string, question: string, answer: string) {
    Navigation.navigate(MainStackScreenNames.Answers, { category, question, answer })
  }
  static goToConstructions() {
    Navigation.navigate(MainStackScreenNames.Constructions)
  }
  static goToConstructionsImageDetail(imageSource: ImageSourcePropType) {
    Navigation.navigate(MainStackScreenNames.ConstructionsImageDetail, { imageSource: imageSource })
  }
  static goToFinance() {
    Navigation.navigate(MainStackScreenNames.Finance)
  }
  static goToFirstLogin() {
    Navigation.replace(AuthStackScreenNames.FirstLogin)
  }
  static goToLogin() {
    Navigation.replace(AuthStackScreenNames.Login)
  }
  static goToSignUp() {
    Navigation.navigate(AuthStackScreenNames.SignUp)
  }
  static goToSignUpVerification() {
    Navigation.replace(AuthStackScreenNames.SignUpVerification)
  }
  static goToMainScreen() {
    Navigation.replace(MainStackScreenNames.Dashboard)
  }
  static goToPasswordRecovery() {
    Navigation.navigate(AuthStackScreenNames.PasswordRecovery)
  }
  static goToSecondPasswordRecoveryScreen() {
    Navigation.replace(AuthStackScreenNames.SecondPasswordRecoveryScreen)
  }
  static goToRedefinePassword() {
    Navigation.navigate(AuthStackScreenNames.RedefinePassword)
  }
  static goToOnboarding() {
    Navigation.replace(MainStackScreenNames.Onboarding)
  }
  static goToTransition() {
    Navigation.replace(MainStackScreenNames.Transition)
  }
  static goToPayInstallment(installmentInfo: any) {
    Navigation.navigate(FinanceScreenNames.PayInstallment, { installmentInfo: installmentInfo })
  }
  static goToDuplicateScreen(installmentInfo?: any) {
    Navigation.replace(FinanceScreenNames.Duplicate, { installmentInfo: installmentInfo })
  }
  static goToFinanceFuture() {
    Navigation.replace(MainStackScreenNames.Finance)
  }
  static goToAnticipateInstallment() {
    Navigation.replace(FinanceScreenNames.AnticipateInstallment)
  }
  static goToNotificationsScreen() {
    Navigation.navigate(MainStackScreenNames.Notifications)
  }
  static logout() {
    Navigation.replace(AuthStackScreenNames.Login)
  }
  static goToProfile() {
    Navigation.navigate(MainStackScreenNames.Profile)
  }
  static goToChangeNameScreen() {
    Navigation.navigate(MainStackScreenNames.ChangeName)
  }
  static goToChangePasswordScreen() {
    Navigation.navigate(MainStackScreenNames.ChangePassword)
  }
  static goToGenericInfoScreen(context: GenericInfoScreenContext, hasSignUpScreenAsOrigin?: boolean) {
    Navigation.navigate(MainStackScreenNames.GenericCompanyInfo, { context, hasSignUpScreenAsOrigin })
  }
}
